import React from "react";
import { useEditorStore } from "../../../../../state/editorStore";
import PaddingPill from "./PaddingPill";
import styles from "./Padding.module.css";

const Padding = () => {
  const layout = useEditorStore(state => state.layout);
  const updateLayout = useEditorStore(state => state.updateLayout);

  return (
    <div className={styles.container}>
      <div className={styles.title}>Padding</div>

      <div className={styles.grid}>
        <PaddingPill
          direction="top"
          value={layout.paddingTop}
          onChange={(v) => updateLayout("paddingTop", v)}
        />

        <PaddingPill
          direction="right"
          value={layout.paddingRight}
          onChange={(v) => updateLayout("paddingRight", v)}
        />

        <PaddingPill
          direction="bottom"
          value={layout.paddingBottom}
          onChange={(v) => updateLayout("paddingBottom", v)}
        />

        <PaddingPill
          direction="left"
          value={layout.paddingLeft}
          onChange={(v) => updateLayout("paddingLeft", v)}
        />
      </div>
    </div>
  );
};

export default Padding;